const collapseContextKey = Symbol("collapseContextKey");

export { collapseContextKey };
//# sourceMappingURL=constants.mjs.map
